/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import cn from "classnames";

import { useState } from "react";

function useImgSet() {
  const getImg = (name, ext = "png", className = []) => {
    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);

    const a = require(`../assets/img/${name}.${ext}`);
    const b = require(`../assets/img/${name}@2x.${ext}`);
    const c = require(`../assets/img/${name}@3x.${ext}`);

    const handleOnLoad = ({ target }) => {
      setWidth(target.naturalWidth);
      setHeight(target.naturalHeight);
    };

    return (
      <img
        src={a}
        srcSet={`${a}, ${b} 2x, ${c} 3x`}
        width={width}
        height={height}
        alt=""
        className={cn(className)}
        onLoad={handleOnLoad}
      />
    );
  };

  return getImg;
}

export default useImgSet;
